import { router } from '../router';
import axios from 'axios'

const API_URL = 'http://localhost:8090/'
//const LOGIN_URL = API_URL + 'sessions/create'
const LOGIN_URL = API_URL + 'auth'
const SIGNUP_URL = API_URL + 'users/'

export default {
  user: {
    authenticated: false
  },
 admin: {
    authenticated: false
  },
  teacher: {
    authenticated: false,
    attendance: false,
    teacher_id:'',
    token_time:'',
    teacher_info:{},
    teacher_name:''
  }, login_or_signup(action, context, creds, redirect) {
    let url = ''
    switch(action) {
      case 'login':
          url = LOGIN_URL;
          break;
      case 'signup':
          url = SIGNUP_URL;
          break;
      default:
          url = LOGIN_URL;
    }
      //  router.push(redirect);

 /*    axios.post(url, creds)
      .then((response) => {
        localStorage.setItem('id_token', response.data.id_token)

    //   console.log ('response', response.data.id_token);

        this.user.authenticated = true

     if(redirect) {
          console.log ('redirect', redirect)
          router.push(redirect)
        } 
                 //  router.push({path: '/family'})


      }).catch((err) => {
     context.error = err.response.data
      //console.log('in error', err.response.data)
      }) */
  },

  logout() {
    localStorage.removeItem('teach_token')
    this.user.authenticated = false;
    this.admin.authenticated = false;
    this.teacher.authenticated = false;
 //   window.location.reload(true); // logout complete reload login from server. basically start from scratch, lose all user data info.
    
  },

  checkAuth() {
    var jwt = localStorage.getItem('teach_token')
    if(jwt) {
      this.user.authenticated = true
    } else {
      this.user.authenticated = false
    }
  },

  getAuthHeader() {
    return {
      'Authorization': 'Bearer ' + localStorage.getItem('teach_token')
    }
  }
}



// WEBPACK FOOTER //
// ./src/auth/index.js